import React from 'react';
import { COPY_SPECIFIC, URLS } from '@sonar-software/sonar-ts-constants';
export const TermsOfServiceLink = () => React.createElement("a", { href: URLS.TERMS_OF_SERVICE, rel: 'noopener', target: '_blank' }, COPY_SPECIFIC.TERMS_OF_SERVICE);
